import { useEffect, useRef } from "react";
import { metadataAPI } from "../api/metadata";
import { useWhoAmI } from "./useWhoAmI";

/**
 * Persists the current concern into user metadata (`lastConcernIds`, max 3) once per
 * loaded concern when the user is logged in. Refreshes `getUserMetadata` on success.
 */
export function useRecordConcernVisit() {
  const { confirmedLoggedIn, concernId } = useWhoAmI();
  const lastSentRef = useRef<number | null>(null);

  useEffect(() => {
    if (!confirmedLoggedIn || !concernId || concernId <= 0) return;
    if (lastSentRef.current === concernId) return;
    lastSentRef.current = concernId;

    void (async () => {
      try {
        metadataAPI.recordConcernVisit({ concernId });
      } catch {
        /* ignore */
      }
    })();
  }, [confirmedLoggedIn, concernId]);
}
